module.exports = __webpack_public_path__ + "img/image49.7264993b.webp";